/**
 * Identidad del equipo: a qué negocio, sucursal y caja pertenece. Se guarda en el
 * almacenamiento de la plataforma y se completa una sola vez al registrar el equipo.
 */
import { platform } from "@/platform";

export interface DeviceState {
  deviceId: string;
  businessId: string;
  businessSlug: string;
  locationId: string | null;
  cashRegisterId: string | null;
  prefix: string;
  status: "pending" | "approved" | "blocked" | "retired";
  entitlement: string | null; // token firmado
  /** Modo soporte del super admin ("entrar como este negocio"), solo web. */
  support?: { sessionId: string; businessName: string; reason: string } | null;
}

const KEY = "sofia.device";
let current: DeviceState | null = null;
const listeners = new Set<(s: DeviceState | null) => void>();

export const deviceState = {
  get: () => current,
  async load() {
    const raw = await platform.store.getItem(KEY);
    current = raw ? (JSON.parse(raw) as DeviceState) : null;
    listeners.forEach((l) => l(current));
    return current;
  },
  async set(next: DeviceState | null) {
    current = next;
    if (next) await platform.store.setItem(KEY, JSON.stringify(next));
    else await platform.store.removeItem(KEY);
    listeners.forEach((l) => l(current));
  },
  async patch(p: Partial<DeviceState>) {
    if (!current) return;
    await this.set({ ...current, ...p });
  },
  subscribe(l: (s: DeviceState | null) => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
